// src/components/coaches/SearchBar/SearchBar.jsx
import React from "react";
import "./SearchBar.css";
import SearchIcon from "@material-ui/icons/Search";


export default function SearchBar({ value, onChange, placeholder }) {
  return (
    <div className="searchbar-container">
      <div className="searchbar-input-wrapper">
        <span className="material-symbols-outlined searchbar-icon"><SearchIcon/></span>

        <input
          className="searchbar-input"
          type="text"
          value={value}
          onChange={function (e) {
            if (onChange) onChange(e.target.value);
          }}
          placeholder={placeholder || "Search..."}
        />
      </div>
    </div>
  );
}
